export default __webpack_public_path__ + "static/media/magazine.3319bbde.webp";